// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const fountain = defineModel({
  id: "fountain",
  batchId: "future",
  name: "Fountain",
  tags: ["building","fountain","low-poly","age-of-mcp","future","water"],
  summary: "A civic fountain — public water with a touch of prestige.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 1,
  defaultVariant: "complete",
  variants: [
    { id: "stage-0", label: "Foundation", parts: () => [
      { geometry: new THREE.BoxGeometry(1.8, 0.14, 1.8), color: "#5a5a5a", position: [0, 0.07, 0] },
    ] },
    { id: "stage-1", label: "Lower", parts: () => [
      { geometry: new THREE.BoxGeometry(1.8, 0.14, 1.8), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.CylinderGeometry(0.78, 0.82, 0.22, 16), color: "#9a958a", position: [0, 0.25, 0] },
      { geometry: new THREE.CylinderGeometry(0.83, 0.83, 0.06, 16), color: "#7c776c", position: [0, 0.36, 0] },
      { geometry: new THREE.CylinderGeometry(0.74, 0.74, 0.04, 16), color: "#4a86a4", position: [0, 0.31, 0] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.5, 4), color: "#6b4a26", position: [-0.8, 0.25, -0.8] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.5, 4), color: "#6b4a26", position: [0.8, 0.25, -0.8] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.5, 4), color: "#6b4a26", position: [-0.8, 0.25, 0.8] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.5, 4), color: "#6b4a26", position: [0.8, 0.25, 0.8] },
    ] },
    { id: "stage-2", label: "Upper", parts: () => [
      { geometry: new THREE.BoxGeometry(1.8, 0.14, 1.8), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.CylinderGeometry(0.78, 0.82, 0.34, 16), color: "#9a958a", position: [0, 0.31, 0] },
      { geometry: new THREE.CylinderGeometry(0.83, 0.83, 0.06, 16), color: "#7c776c", position: [0, 0.48, 0] },
      { geometry: new THREE.CylinderGeometry(0.74, 0.74, 0.04, 16), color: "#4a86a4", position: [0, 0.43, 0] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.7, 4), color: "#6b4a26", position: [-0.8, 0.35, -0.8] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.7, 4), color: "#6b4a26", position: [0.8, 0.35, -0.8] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.7, 4), color: "#6b4a26", position: [-0.8, 0.35, 0.8] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.7, 4), color: "#6b4a26", position: [0.8, 0.35, 0.8] },
    ] },
    { id: "complete", label: "Complete", parts: () => [
      { geometry: new THREE.BoxGeometry(1.8, 0.14, 1.8), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.CylinderGeometry(0.78, 0.82, 0.36, 16), color: "#9a958a", position: [0, 0.32, 0] },
      { geometry: new THREE.CylinderGeometry(0.83, 0.83, 0.06, 16), color: "#7c776c", position: [0, 0.5, 0] },
      { geometry: new THREE.CylinderGeometry(0.74, 0.74, 0.04, 16), color: "#4a86a4", position: [0, 0.45, 0] },
      { geometry: new THREE.CylinderGeometry(0.12, 0.16, 0.4, 10), color: "#9a958a", position: [0, 0.65, 0] },
      { geometry: new THREE.CylinderGeometry(0.3, 0.12, 0.1, 14), color: "#7c776c", position: [0, 0.9, 0] },
      { geometry: new THREE.CylinderGeometry(0.27, 0.27, 0.03, 14), color: "#4a86a4", position: [0, 0.94, 0] },
      { geometry: new THREE.CylinderGeometry(0.04, 0.05, 0.16, 8), color: "#9a958a", position: [0, 1.01, 0] },
      { geometry: new THREE.SphereGeometry(0.05, 6, 5), color: "#bfe0ef", position: [0, 1.15, 0] },
      { geometry: new THREE.SphereGeometry(0.035, 6, 5), color: "#bfe0ef", position: [0.1, 1.09, 0.04] },
      { geometry: new THREE.SphereGeometry(0.035, 6, 5), color: "#bfe0ef", position: [-0.09, 1.07, -0.05] },
    ] },
  ],
  animations: [],
});
